import React from 'react';
import block from 'bem-cn-lite';
import {Check} from '@gravity-ui/icons';

import './ManagementAccInfo.scss';

const b = block('management-acc-info');

interface ManagementAccInfoProps {
    managementAccount: boolean;
    className?: string;
}

export const ManagementAccInfo: React.FC<ManagementAccInfoProps> = ({
    managementAccount,
    className
}) => {
    return <div className={`${b('block', className)}`}>{managementAccount && <Check />}</div>;
};
